import { Injectable } from '@angular/core';
import { ApiService } from '../core/services/api.service';
import { ConfigService } from '../core/services/config.service';
import { APIENDPOINTS } from '../common/constants';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObligationService {

  constructor(private apiService: ApiService, private configService: ConfigService) {
  }

  //This method performs a keyword seach and return all matching PCTs and Species
  searchCredit(category: string, keyword: any, subregion: string): Observable<any> {
    if (category == null || category.trim() == "" || keyword == null || keyword.trim() == "") return null;
    const searchUrl = category.startsWith("E") ? "/api/credit/search/pct/" : "/api/credit/search/species/";
    return this.apiService.find(this.configService.gatewayBaseUrl + searchUrl + keyword);
  }

  getTradingGroups(pct: number): Observable<any> {
    if (pct == null || pct <= 0) return null;
    return this.apiService.find(this.configService.gatewayBaseUrl + "/api/credit/pct/" + pct + "/tradinggroups");
  }
}
